/**
 * This file is used to define the jquery global that is used for the test bridge
 */

window.$ = window.jQuery = require('jquery');
